// extracted by mini-css-extract-plugin
export default {"popover":"popover--BEabJ"};